module.exports = "<div class=\"quickstart buttons\">\n  <router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/quickstarts/quickstart-buttons/buttons.component.html
// module id = 1553
// module chunks = 2